<template>
  <div class="mall-result-message">
    <img class="mall-result-message__icon" :src="icon" alt="" />
    <div class="mall-result-message__text">
      <span class="typo-lg-semi">{{ title }}</span>
      <span class="typo-body-s-medium mall-result-message__desc">
        <span v-for="line in messageLines" :key="line" class="mall-result-message__line">{{ line }}</span>
      </span>
    </div>
  </div>
</template>

<script>
// 결제 결과 안내 (아이콘 + 제목 + 안내 문구)
export default {
  name: 'MallResultMessage',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    // 줄 단위 안내 문구
    messageLines: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.mall-result-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.mall-result-message__icon {
  display: block;
  width: 120px;
  height: 120px;
  object-fit: cover;
}

.mall-result-message__text {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
  text-align: center;
}

.mall-result-message__desc {
  color: #4E5968;
}

.mall-result-message__line {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallResultMessage.vue